import UpdateInitializeSnippet from "snippets/purekit/rotate-records/initialize";
import PerformRotationSnippet from "snippets/purekit/rotate-records/perform-rotation";
import RotateConfigureSnippet from "snippets/purekit/rotate-records/configure";
import * as React from 'react';
export default {
  UpdateInitializeSnippet,
  PerformRotationSnippet,
  RotateConfigureSnippet,
  React
};